import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "mustitest-e5e0a",
  appId:
    import.meta.env.VITE_FIREBASE_APP_ID ??
    "1:900159616750:web:ef3ea7daddfeb893bee5ff",
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ??
    "mustitest-e5e0a.firebasestorage.app",
  apiKey:
    import.meta.env.VITE_FIREBASE_API_KEY ??
    "AIzaSyCkLyQesSWznh5sSE5tqqLWjb-p_eHgDiU",
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ??
    "mustitest-e5e0a.firebaseapp.com",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "900159616750",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
